import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { cn } from "./utils.js";
const badgeVariants = cva("inline-flex items-center rounded-sm px-2.5 py-1 text-[0.7rem] font-bold leading-none tracking-wide", {
    variants: {
        tone: {
            attention: "bg-amber-100 text-amber-900",
            danger: "bg-red-100 text-red-800",
            neutral: "bg-stone-100 text-stone-700",
            positive: "bg-emerald-100 text-emerald-900",
        },
    },
    defaultVariants: { tone: "neutral" },
});
export function Badge({ className, tone, ...props }) {
    return _jsx("span", { className: cn(badgeVariants({ className, tone })), ...props });
}
